import React from "react";
import SanitizedHTML from "react-sanitized-html";

import { withFormik } from "formik";
import Yup from "yup";
const TOKEN_KEY = "jwt";
const date = new Date();

export const login = () => {
  localStorage.setItem("isLoggedin", true);
  // sessionStorage.setItem('isLoggedin', true);
};

export const logout = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("isLoggedin");
};

export const isLogin = () => {
  if (localStorage.getItem("isLoggedin")) {
    return true;
  }
};

// export const apiURL = (method) => {
//   //return "https://navdishaapi.navneet.com/admin/" + method; // prod
//    return "https://navdishastagingapi.navneet.com/admin/" + method; // admin stage
//   // return "https://navdishaadminapi.navneet.com/api/" + method; // prod
//   // return "https://navdishastaging.navneet.com/navneet/api/" + method; //stage
//   // return "http://localhost:3000/" + method; //local
// };

// export const teacherApiURL = (method) => {
//  // return "https://navdishaapi.navneet.com/admin/" + method; // prod
//   return "https://navdishastagingapi.navneet.com/admin/" + method; // stage
//   // return "http://localhost:3000/admin/" + method; // local server
// };

// // export const loginAPIURL = (method) => {
// //   // return "https://navdishaapi.navneet.com/login"; // prod
// //   if(method) return `https://navdishaapi.navneet.com/login/${method}`
// //    return "https://navdishaapi.navneet.com/login"; // stage
// //   // return "http://localhost:3000/admin/" + method; // local server
// //   // return "http://localhost:3000/login"; // admin stage
// // };
// export const loginAPIURL = (method) => {
//   if (method) {
//     return `https://navdishastagingapi.navneet.com/login/${method}`;
//   }
//   return "https://navdishastagingapi.navneet.com/login";
// };
// // TODO - for the time being solution
// export const registerAPIURL = (method)=>{
//  // return "https://navdishaapi.navneet.com/" + method; // prod
//  return "https://navdishastagingapi.navneet.com/" + method; // admin stage
//   // return "https://navdishaadminapi.navneet.com/api/" + method; // prod
//   // return "https://navdishastaging.navneet.com/navneet/api/" + method; //stage
//   // return "http://localhost:3000/" + method; //local
// }
/*  ONLY THIS PART CHANGED (API DYNAMIC) */
const getBaseURL = () => {
  const host = window.location.hostname;

  // LOCAL → STAGING
  if (host.includes("localhost")) {
    return "https://navdishastagingapi.navneet.com/";
  }

  // STAGING (Teacher + Admin)
  if (
    host.includes("navdishateacherstaging") ||
    host.includes("navdishaadminstaging")
  ) {
    return "https://navdishastagingapi.navneet.com/";
  }

  // PRODUCTION (Teacher + Admin)
  if (
    host.includes("navdisha.navneet.com") ||
    host.includes("navdishaadmin.navneet.com")
  ) {
    return "https://navdishaapi.navneet.com/";
  }

  // fallback (safe → staging)
  return "https://navdishastagingapi.navneet.com/";
};

export const apiURL = (method) => {
  return getBaseURL() + "admin/" + method;
};

export const teacherApiURL = (method) => {
  return getBaseURL() + "admin/" + method;
};
export const bannerApiUrl = (method) => {
  return getBaseURL() + method;
};

export const loginAPIURL = (method) => {
  const base = getBaseURL() + "login";
  if (method) {
    return base + "/" + method;
  }
  return base;
};

export const registerAPIURL = (method) => {
  return getBaseURL() + method;
};

export const getCurrentDate = () => {
  return date.getDate();
};

export const getCurrentMonth = () => {
  let currentMonth = date.getMonth() + 1;
  return currentMonth < 10 ? 0 + "" + currentMonth : currentMonth;
};
export const getCurrentYear = () => {
  return date.getFullYear();
};

export const getCurrentTime = () => {
  return date.toLocaleString();
};


export const getAMPM = () => {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

export const formatDateTime = () => {
  return (
    getCurrentDate() +
    "-" +
    getCurrentMonth() +
    "-" +
    getCurrentYear() +
    ":" +
    getCurrentTime() +
    ":" +
    getAMPM()
  );
};

export const change_date_format = (str) => {
  let date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

export const get_changed_time = (str, getampm) => {
  let date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  let hours = ("0" + date.getHours()).slice(-2);
  //let minutes = ("0" + date.getMinutes()).slice(-2);
  let minutes = ("" + date.getMinutes()).slice(-2);
  let seconds = ("0" + date.getSeconds()).slice(-2);
  let ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  if (getampm === true) {
    // return [hours, minutes, seconds ].join(":")+' '+ampm;
    return [hours, minutes].join(":") + " " + ampm; // if require date time with ampm pass second parameter true
  } else {
    // return [hours, minutes, seconds ].join(":");
    return [hours, minutes].join(":");
  }
};

export const addMinutesToTime = (data) => {
  // Parse the fldt_time into a Date object
  const date = new Date(data.fldt_time);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid fldt_time format");
  }

  // Convert fldv_duration to a number and add it as minutes
  const durationMinutes = parseInt(data.fldv_duration, 10);
  if (isNaN(durationMinutes)) {
    throw new Error("Invalid fldv_duration format");
  }

  date.setMinutes(date.getMinutes() + durationMinutes);

  // Return the updated time as a string
  return date.toISOString();
};

export const sanitizeHtml = (str) => {
  return <SanitizedHTML html={str} />;
};
